export default "__VITE_ASSET__B83jS5n1__"